import axios from "axios";
import appConfig from "../../config/app.config";

export default axios.create({
  baseURL: appConfig.apiURL,
  headers: {
    "Content-type": "application/json",
  },
});
